import { Logo } from '~/components/modules/Logo/Logo';

export const CreateAccountTopBar = () => {
    return (
        <>
            <a href={'#main-content'} className={'skip-nav'}>
                Skip to main content
            </a>
            <nav className={'lg:shadow-none bg-white'}>
                <div className={'mx-auto px-4 sm:px-6 lg:px-12 flex items-center'}>
                    <div className={'lg:mr-8 xs:w-[60px] xs:h-[60px] xs:mx-auto md:w-[74px] md:h-[76px] md:mx-0'}>
                        <Logo type={'standard'} className={'xs:w-[60px] xs:h-[60px]'} />
                    </div>
                </div>
            </nav>
        </>
    );
};
